import React, { useMemo, useState } from "react";
import ShowContainer from "../ShowContainer";
import IconFavorite from "../JSXIcons/IconFavorite";
import { useTranslation } from "react-i18next";
import "./game-item.scss";
import { useDispatch } from "react-redux";
import { API_USER } from "../../../api/user";
import { DEBUG, TEST_MODE } from "../../../store/enums";
import { addFavoriteGames, removeFavoriteGames } from "../../../store/gamesSlice";
import IconProviders from "../JSXIcons/IconProviders";
import useGameClick from "../../../hooks/other/useGameClick";
import { errorToast } from "../Toaster.jsx";
import useLoginAction from "../../../hooks/useLoginAction";
import { useAppSelector } from "../../../store/index.ts";
import DeleteHisGameModal from "../../modal/delete_game_his_modal/DeleteGameHisModal.jsx";

export default function GameItem({
  className = "game",
  url = "/game/",
  image,
  imageHover = "",
  hideFavorites,
  name,
  author,
  urlParam,
  isChoose = true,
  currentGame = {},
  imgAlt,
  isHistoryGames,
  isCarousel
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { onLoginAction } = useLoginAction();

  const favoriteGamesId = useAppSelector((state) => state.games.favorites.ids);

  const id = currentGame.game_id || currentGame.id;
  const isFavorite = useMemo(() => favoriteGamesId.includes(id), [favoriteGamesId, id]);
  const isFavoriteClass = useMemo(() => (isFavorite ? "favorite" : ""), [isFavorite]);

  const [hover, setHover] = useState(false);
  const [isDelete, setIsDelete] = useState(false);

  // TODO - временно скрыто
  // const countOnline = 0;

  const { onGameClick } = useGameClick();

  const onItemGameClick = () => {
    onGameClick({ currentGame, isChoose, url, urlParam });
  };

  const onFavorites = () => {
    !isFavorite
      ? dispatch(addFavoriteGames(currentGame))
      : dispatch(removeFavoriteGames(currentGame));

    if (TEST_MODE) return;

    API_USER.toggleFavorites(id)
      .then((e) => {
        if (DEBUG) console.log("favorites res", e);
        const isFavorites = e.data.favorites;
        isFavorites
          ? dispatch(addFavoriteGames(currentGame))
          : dispatch(removeFavoriteGames(currentGame));
      })
      .catch((e) => {
        errorToast(e.message);
        isFavorite
          ? dispatch(addFavoriteGames(currentGame))
          : dispatch(removeFavoriteGames(currentGame));
        if (DEBUG) console.log("catch", e);
      });
  };

  // const provider = currentGame.providerName || currentGame.provider;
  const provider = currentGame.providerName;
  const carouselClass = isCarousel ? "carousel-item" : "";
  const urlImg = imageHover && hover ? imageHover : image;

  const onCrossClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDelete(true);
  };

  return (
    <>
      <div
        className={`${className}__item ${carouselClass}`}
        onClick={onItemGameClick}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}>
        <div className={`${className}__item__photo`}>
          <img className={`${className}__img`} alt={imgAlt || "image " + name} src={urlImg} />

          <ShowContainer condition={!hideFavorites}>
            <button
              id={id}
              data-currentGame={currentGame}
              className={`${className}__item__favorite ${isFavoriteClass}`}
              aria-label={t("game favorite")}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onLoginAction(onFavorites);
              }}>
              <IconFavorite />
            </button>
          </ShowContainer>

          <ShowContainer condition={isHistoryGames}>
            <button className={`${className}__item__hidden`} onClick={onCrossClick}>
              <span className="x">X</span>
            </button>
          </ShowContainer>
        </div>
        <ShowContainer condition={provider}>
          <p className={`${className}__item__provider`}>
            <IconProviders />
            <span>{provider}</span>
          </p>
        </ShowContainer>
        <ShowContainer condition={name}>
          <p className={`${className}__item__name`}>{t(name)}</p>
        </ShowContainer>
        <ShowContainer condition={author}>
          <span className={`${className}__item__author`}>{t(author)}</span>
        </ShowContainer>
      </div>

      <DeleteHisGameModal
        isOpen={isDelete}
        closeModal={() => setIsDelete(false)}
        currentGame={currentGame}
      />
    </>
  );
}
